import styled from 'styled-components';
import { Menu, MenuItem } from '@landlord-tech/ui-kit-opp/dist/components/Menu';
import { TMenuItemProps, TMenuProps } from './Menu.types';

const SMenu = styled(Menu)<TMenuProps>``;

const SMenuItem = styled(MenuItem)<TMenuItemProps>``;
export { SMenu, SMenuItem };
